import 'regenerator-runtime/runtime';
import {
  put,
  call,
  takeLatest,
  all
} from 'redux-saga/effects';
import {
  getSubcontractorPurchaseOrderList,
  getSubcontractorPurchaseOrderDetail,
  createPurchaseOrder,
  getPurchaseOrderList,
  getPurchaseOrderDetail,
  editPurchaseOrder,
  resendPurchaseOrder,
  purchaseOrderAttachments,
  printPreviewPurchaseOrder,
  printPreviewSubcontractorPurchaseOrder
} from './api';
import * as PurchaseOrderTypes from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getPurchaseOrderListAsync(action) {
  const result = yield call(getPurchaseOrderList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_SUCCESS, data: {data: result.data, params: action.params.data}});
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
      put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_FAIL})
    ];
  }
}

export function* getPurchaseOrderDetailAsync(action) {
  const result = yield call(getPurchaseOrderDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_SUCCESS, data: result.data});
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
      put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_FAIL})
    ];
  }
}

export function* createPurchaseOrderAsync(action) {
  const result = yield call(createPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.params.isUploadAttachment) {
      if (action.callback) {
        action.callback(result.data, true);
      }
    } else {
      if (action.callback) {
        action.callback(result.data, false);
      }
      yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Purchase order created' });
    }

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* editPurchaseOrderAsync(action) {
  const result = yield call(editPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data, true);
    }
    if (action.params.isUploadAttachment) {
      yield [
        put({type: PurchaseOrderTypes.EDIT_PURCHASE_ORDER_SUCCESS, data: result.data})
      ];
    } else {
      yield [
        put({type: PurchaseOrderTypes.EDIT_PURCHASE_ORDER_SUCCESS, data: result.data}),
        put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
      ];
    }

  } else {
    if (action.callback) {
      action.callback(result.data, false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* resendPurchaseOrderAsync(action) {
  const result = yield call(resendPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {

    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];

  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* purchaseOrderAttachmentsAsync(action) {
  const result = yield call(purchaseOrderAttachments, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true);
    }
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });

  } else {
    if (action.callback) {
      action.callback(false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getSubcontractorPurchaseOrderListAsync(action) {
  const result = yield call(getSubcontractorPurchaseOrderList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_SUCCESS, data: {data: result.data, params: action.params.data}});
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
      put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_FAIL})
    ];
  }
}

export function* getSubcontractorPurchaseOrderDetailAsync(action) {
  const result = yield call(getSubcontractorPurchaseOrderDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({type: PurchaseOrderTypes.GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_SUCCESS, data: result.data});
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
      put({type: PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_FAIL})
    ];
  }
}

export function* printPreviewPurchaseOrderAsync(action) {
  const result = yield call(printPreviewPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* printPreviewSubcontractorPurchaseOrderAsync(action) {
  const result = yield call(printPreviewSubcontractorPurchaseOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchPurchaseOrder() {
  yield all([
    takeLatest(PurchaseOrderTypes.GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC, getSubcontractorPurchaseOrderListAsync),
    takeLatest(PurchaseOrderTypes.GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC, getSubcontractorPurchaseOrderDetailAsync),
    takeLatest(PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_ASYNC, getPurchaseOrderListAsync),
    takeLatest(PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_ASYNC, getPurchaseOrderDetailAsync),
    takeLatest(PurchaseOrderTypes.CREATE_PURCHASE_ORDER_ASYNC, createPurchaseOrderAsync),
    takeLatest(PurchaseOrderTypes.EDIT_PURCHASE_ORDER_ASYNC, editPurchaseOrderAsync),
    takeLatest(PurchaseOrderTypes.RESEND_PO_ASYNC, resendPurchaseOrderAsync),
    takeLatest(PurchaseOrderTypes.PURCHASE_ORDER_ATTACHMENTS_ASYNC, purchaseOrderAttachmentsAsync),
    takeLatest(PurchaseOrderTypes.PRINT_PREVIEW_PURCHASE_ORDER_ASYNC, printPreviewPurchaseOrderAsync),
    takeLatest(PurchaseOrderTypes.PRINT_PREVIEW_SUBCONTRACTOR_PURCHASE_ORDER_ASYNC, printPreviewSubcontractorPurchaseOrderAsync)

  ]);
}



// WEBPACK FOOTER //
// ./src/Purchase-Orders/saga.js